export default __webpack_public_path__ + "static/media/expandChart.bd2f3e68.svg";